import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { TrustDetailsClient } from "../../../../../../../../Wrap/Api/Account/TrustDetails";
import { AdviserBridgePermissionCheckClient } from "../../../../../../../../Wrap/Api/Customer/AdviserBridgePermissionCheck";
import { CheckAdviserBridgeAccountPermissionsClient } from "../../../../../../../../Wrap/Api/Customer/CheckAdviserBridgeAccountPermissions";
import { SippIncomeClient } from "../../../../../../../../Wrap/Api/PortfolioAnalysis/Investment/SippIncome";
import { PerformanceSummaryClient } from "../../../../../../../../Wrap/Api/PortfolioAnalysis/Performance/PerformanceSummary";
import { NewPortfolioValuationSummaryClient } from "../../../../../../../../Wrap/Api/Transformation/NewPortfolioValuationSummary";
import { NewProductsValuationDetailSummaryClient } from "../../../../../../../../Wrap/Api/Transformation/NewProductsValuationDetailSummary";
import { AssetClassType } from "../../../../../../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { DateFromType } from "../../../../../../../../Wrap/Constants/Enums/Domain/Transformation/Valuation/DateFromType";
import { PortfolioValuationSummary } from "../../../../../../../../Wrap/Models/Domains/Valuation/PortfolioValuationSummary";
import { ProductsValuationDetailSummary } from "../../../../../../../../Wrap/Models/Domains/Valuation/ProductsValuationDetailSummary";
import { PerformanceMethod } from "../../../../../../../../Wrap/Models/Models/Transformation/Performance/PerformanceMethod";
import { IJsonDate } from "../../../../../../../../Wrap/System/IJsonDate";
import { PortfolioDashboardMultiSelectionStore } from "../../../Store/Variable";
import {
    PortfolioPerformanceSimpleReturnAndIRRDispatcher,
    PortfolioPerformanceSummaryDispatcher,
    PortfolioPerformanceSummaryQuery,
    ProductsValuationDetailSummaryDispatcher,
    ProductsValuationDetailSummaryQuery,
    SippIncomeDispatcher,
    SummaryTrustDetailsDisaptcher,
} from "../Store/Variable";

export class PortfolioDashboardSummaryAction {
    public static getPortfolioValuationSummary(
        headAccountHierarchyIds: Array<string>,
        subAccountHierarchyIds: Array<string>,
        assetClassType: AssetClassType,
        performanceMethod: PerformanceMethod,
        asAt: IJsonDate,
        dateFromType: DateFromType,
        callBack?: (val: PortfolioValuationSummary) => void
    ) {
        assetClassType = AssetClassType.Tier1;
        performanceMethod = PerformanceMethod.Simple;
        dateFromType = 1;

        const client = new NewPortfolioValuationSummaryClient();
        const promise = client.post(
            headAccountHierarchyIds,
            subAccountHierarchyIds,
            assetClassType,
            performanceMethod,
            asAt,
            dateFromType
        );
        promise.onSuccess((res) => {
            if (callBack) {
                callBack(res);
            }
        });

        promise.onError((err) => {
            console.error(err);
        });
    }

    public static getPerformanceSummary(query: PortfolioPerformanceSummaryQuery) {
        const client = new PerformanceSummaryClient();
        const promise = client.get(
            query.hierarchyId,
            query.fromDateTime,
            query.toDateTime,
            query.fromInception,
            query.performanceMethod,
            PortfolioDashboardMultiSelectionStore.getData()
        );

        PortfolioPerformanceSummaryDispatcher.dispatch({
            actionType: ActionType.Loading,
            query: query,
        });

        promise.onSuccess((res) => {
            PortfolioPerformanceSummaryDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: res,
                query: query,
            });
        });

        promise.onError((err) => {
            PortfolioPerformanceSummaryDispatcher.dispatch({
                actionType: ActionType.Error,
                query: query,
            });
        });
    }

    public static getProductsValuationDetailSummary(query: ProductsValuationDetailSummaryQuery) {
        const client = new NewProductsValuationDetailSummaryClient();
        const promise = client.get(
            query.headAccountHierarchyIds,
            query.subAccountHierarchyIds,
            query.assetClassType,
            query.asAt
        );

        ProductsValuationDetailSummaryDispatcher.dispatch({
            actionType: ActionType.Loading,
            query: query,
        });

        promise.onSuccess((res) => {
            ProductsValuationDetailSummaryDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: res,
                query: query,
            });
        });

        promise.onError((err) => {
            ProductsValuationDetailSummaryDispatcher.dispatch({
                actionType: ActionType.Error,
                query: query,
            });
        });
    }

    public static getSippIncome(hierarchyId: string) {
        const client = new SippIncomeClient();
        const promise = client.get(hierarchyId);

        SippIncomeDispatcher.dispatch({
            actionType: ActionType.Loading,
            query: hierarchyId,
        });

        promise.onSuccess((res) => {
            SippIncomeDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: res,
                query: hierarchyId,
            });
        });

        promise.onError((err) => {
            SippIncomeDispatcher.dispatch({
                actionType: ActionType.Error,
                query: hierarchyId,
            });
        });
    }

    public static getTrustDetails(hierarchyIds: string[]) {
        const client = new TrustDetailsClient();
        const promise = client.get(hierarchyIds);

        promise.onSuccess((res) => {
            SummaryTrustDetailsDisaptcher.dispatch({
                actionType: ActionType.Success,
                payload: res,
                query: hierarchyIds,
            });
        });

        promise.onError((err) => {
            SummaryTrustDetailsDisaptcher.dispatch({
                actionType: ActionType.Error,
                query: hierarchyIds,
            });
        });
    }

    public static getClientDetails(actorId: number, callback) {
        const client = new AdviserBridgePermissionCheckClient();
        const promise = client.get(actorId);

        promise.onSuccess((res) => {
            callback(res);
        });

        promise.onError((err) => {
            console.error(err);
        });
    }
    public static checkAdviserBridgeAccountPermission(actorId: number, callback) {
        const client = new CheckAdviserBridgeAccountPermissionsClient();
        const promise = client.get(actorId);
        promise.onSuccess((res) => {
            callback(res);
        });

        promise.onError((err) => {
            console.error(err);
        });
    }
}
